import { render } from "./VZTabs.vue?vue&type=template&id=fe5ece52&ts=true"
import script from "./VZTabs.vue?vue&type=script&lang=ts"
export * from "./VZTabs.vue?vue&type=script&lang=ts"

import "./VZTabs.vue?vue&type=style&index=0&id=fe5ece52&lang=scss"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__